import {DefaultDocumentNodeResolver} from 'sanity/structure'
import DocumentsPane from 'sanity-plugin-documents-pane'

/*
 * This is the default document node resolver for the studio.
 * It includes the default form view and a custom view for
 * showing documents that reference the current document.
 */

export const defaultDocumentNodeResolver: DefaultDocumentNodeResolver = (S) =>
  S.document().views([
    S.view.form(),
    S.view
      .component(DocumentsPane)
      .options({
        query: `*[references($id)]`,
        params: {id: `_id`},
      })
      .title('Referenced by'),
  ])
